import { IRole } from './role.model';
import { IUser } from './user.model';
import { IAdresse } from './Adresse.model';

export interface IClient {
  id?: number;
  cni?: string;
  sexe?: string;
  tel?: string;
  etat?: boolean;
  user?: IUser;
  adresses?: IAdresse[];
}

export class Client implements IClient {
  constructor(
    public id?: number,
    public sexe?: string,
    public cni?: string,
    public tel?: string,
    public etat?: boolean,
    public user?: IUser,
    public adresses?: IAdresse[]
  ) {
    this.etat = this.etat || false;
  }
}